import { BaseError } from "./BaseError";
/**
 * NotSupportedError
 */ export class NotSupportedError extends BaseError {
    constructor(name, message){
        super();
        this.message = `${name}${message ? " " + message : ""}`;
        this.name = "NotSupportedError";
    }
}
